import React from "react";
import {
    BorderBottom,
    Message,
    PadlockIcon,
    SectionTitleLeftLine,
    SectionTitleRightLine,
    ServicesIcon
} from "../assets/icons";
import {useLanguage} from "../hooks/LanguageContext";
import ContactInput from "../components/contactUs/contactUsForm/ContactInput";
import Button from "../components/button/Button";
import {TwoFaImg} from "../assets/images";
import Logo from "../components/navbar/Logo";

const LoginPage = () => {
    const {direction,language} = useLanguage();

    const handleOnSubmit = (e) => {
        e.preventDefault();
    }
    return (
        <div className="md:mt-60">

            <div className="hidden md:block">
                <div className='flex items-center justify-center gap-4'>
                    <SectionTitleRightLine />
                    <span className='text-grayscale-600 text-3xl leading-[22.4px] font-bold'>
				{direction === 'rtl' ? 'تسجيل الدخول' : 'Login'}
				</span>
                    <SectionTitleLeftLine />
                </div>

                <ServicesIcon  />
            </div>
            <section className={`max-w-screen-2xl  mx-auto  ${direction === "rtl" ? "text-right" : "text-left"}`}>
                <div className={`flex flex-col ${direction === "rtl" ? "md:flex-row" : "md:flex-row-reverse"} items-center md:gap-[50px] gap-5 `}>

                    <div className={`md:w-1/2 w-full flex flex-col items-center gap-[10px] rounded-[30px] ${direction === "rtl" ? "order-first" : ""}`}>
                        <form
                            onSubmit={handleOnSubmit}
                            className={`flex flex-col items-start w-full md:gap-[50px] gap-6 s md:py-[50px] py-8 md:px-[49px] px-8 ${
                                direction === "rtl" ? "text-right" : "text-left"
                            }`}
                        >
                            <div className="flex flex-col items-start gap-[30px]">
                                <div className="flex flex-col items-start gap-4">
                                    <Logo/>
                                    <h3 className="headline-3-ar text-grayscale-600">
                                        {language === "ar" ? "تسجيل الدخول إلى حسابك" : "Login to your account"}
                                    </h3>
                                    <p
                                        className={`text-base leading-[23.52px] font-medium text-[#3B636B] ${
                                            direction === "rtl" ? "text-right" : "text-left"
                                        }`}
                                    >
                                        {language === "ar"
                                            ? "مرحبًا بك في الفايز، قم بتسجيل الدخول إلى حسابك."
                                            : "Welcome to Alfayez , Login to your account."}
                                    </p>
                                </div>
                                <BorderBottom className="max-w-full" />
                            </div>
                            <ContactInput
                                type={"email"}
                                placeholder={language === "ar" ? "البريد الالكتروني" : "Email"}
                                icon={<Message className="w-[18px] h-[18px]" />}
                            />
                            <ContactInput
                                type={"password"}
                                placeholder={language === "ar" ? "كلمة السر" : "Password"}
                                icon={<PadlockIcon className="w-[18px] h-[18px]" />}
                            />


                            <Button className="w-full rounded-[10px]">
                                {language === "ar" ? "تسجيل دخول" : "Login"}
                            </Button>
                        </form>
                    </div>
                    <div className="md:w-1/2 w-full md:h-[696.69px] h-auto flex flex-col items-center">
                        <img src={TwoFaImg} alt="2faImg" className="w-full" />
                    </div>
                </div>
            </section>



        </div>

    );
};

export default LoginPage;
